var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/wysiwyg-preset.ts
import { BidiExtension } from "@remirror/extension-bidi";
import { BlockquoteExtension } from "@remirror/extension-blockquote";
import { BoldExtension } from "@remirror/extension-bold";
import { CodeExtension } from "@remirror/extension-code";
import { CodeBlockExtension } from "@remirror/extension-code-block";
import { DropCursorExtension } from "@remirror/extension-drop-cursor";
import { IframeExtension } from "@remirror/extension-embed";
import { FindExtension } from "@remirror/extension-find";
import { GapCursorExtension } from "@remirror/extension-gap-cursor";
import { HardBreakExtension } from "@remirror/extension-hard-break";
import { HeadingExtension } from "@remirror/extension-heading";
import { HorizontalRuleExtension } from "@remirror/extension-horizontal-rule";
import { ImageExtension } from "@remirror/extension-image";
import { ItalicExtension } from "@remirror/extension-italic";
import { LinkExtension } from "@remirror/extension-link";
import {
  BulletListExtension,
  OrderedListExtension,
  TaskListExtension
} from "@remirror/extension-list";
import { ShortcutsExtension } from "@remirror/extension-shortcuts";
import { StrikeExtension } from "@remirror/extension-strike";
import { TrailingNodeExtension } from "@remirror/extension-trailing-node";
import { UnderlineExtension } from "@remirror/extension-underline";
var DEFAULT_OPTIONS = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, BidiExtension.defaultOptions), BoldExtension.defaultOptions), CodeBlockExtension.defaultOptions), DropCursorExtension.defaultOptions), FindExtension.defaultOptions), TrailingNodeExtension.defaultOptions), HeadingExtension.defaultOptions);
function wysiwygPreset(options = {}) {
  options = __spreadValues(__spreadValues({}, DEFAULT_OPTIONS), options);
  const gapCursorExtension = new GapCursorExtension();
  const hardBreakExtension = new HardBreakExtension();
  const horizontalRuleExtension = new HorizontalRuleExtension();
  const imageExtension = new ImageExtension();
  const italicExtension = new ItalicExtension();
  const strikeExtension = new StrikeExtension();
  const underlineExtension = new UnderlineExtension();
  const blockquoteExtension = new BlockquoteExtension();
  const codeExtension = new CodeExtension();
  const iframeExtension = new IframeExtension();
  const bulletListExtension = new BulletListExtension();
  const orderedListExtension = new OrderedListExtension();
  const taskListExtension = new TaskListExtension({});
  const shortcutsExtension = new ShortcutsExtension();
  const { selectTextOnClick } = options;
  const linkExtension = new LinkExtension({ autoLink: true, selectTextOnClick });
  const { autoUpdate, defaultDirection, excludeNodes } = options;
  const bidiExtension = new BidiExtension({ autoUpdate, defaultDirection, excludeNodes });
  const { weight } = options;
  const boldExtension = new BoldExtension({ weight });
  const { defaultLanguage, formatter, toggleName, syntaxTheme, supportedLanguages } = options;
  const codeBlockExtension = new CodeBlockExtension({
    defaultLanguage,
    formatter,
    toggleName,
    syntaxTheme,
    supportedLanguages
  });
  const { color, width } = options;
  const dropCursorExtension = new DropCursorExtension({
    color,
    width
  });
  const { defaultLevel, levels } = options;
  const headingExtension = new HeadingExtension({ defaultLevel, levels });
  const { alwaysFind } = options;
  const findExtension = new FindExtension({
    alwaysFind
  });
  const { disableTags, ignoredNodes, nodeName } = options;
  const trailingNodeExtension = new TrailingNodeExtension({
    disableTags,
    ignoredNodes,
    nodeName
  });
  return [
    // Plain
    bidiExtension,
    dropCursorExtension,
    gapCursorExtension,
    findExtension,
    shortcutsExtension,
    trailingNodeExtension,
    // Nodes
    hardBreakExtension,
    imageExtension,
    horizontalRuleExtension,
    blockquoteExtension,
    codeBlockExtension,
    headingExtension,
    iframeExtension,
    bulletListExtension,
    orderedListExtension,
    taskListExtension,
    // Marks
    boldExtension,
    codeExtension,
    strikeExtension,
    italicExtension,
    linkExtension,
    underlineExtension
  ];
}
export {
  wysiwygPreset
};
